import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import { metricTitleMap } from '@intelligence/components/DownloadCommon/DownloadPage/common/baseConfig';
import { getMobileDetailDownloadTitle } from '@intelligence/components/DownloadCommon/DownloadPage/common/baseSetting';
import {
  pipe,
  granularityObject,
  getFileName,
} from '@intelligence/components/DownloadCommon/DownloadPage/utils';
import {
  setItem,
  setMetricTitle,
  setPercentForPCConsole,
  setTitleByDateMethod,
  setTitleByMainGenreShow,
  setTitleByRegionMethod,
  setTitleByFixed,
} from '@intelligence/components/DownloadCommon/DownloadPage/common/titleSettingAtom';
import { toDateTypeNor } from '@/pages/intelligence/utils/common';
import {
  downloadApiListConst,
  sheetNameList,
} from '@intelligence/components/DownloadCommon/DownloadPage/const/marketProfileStatsConst';

// Metrics集合key对应标题
const newMetricMap = {
  ...metricTitleMap,
};

// 根据用户勾选下载页签，获取对应页签配置
const getPageConfig = (params: any) => {
  const downloadMetrics: any = params?.download_metrics || [];
  const dataSource = params?.filter?.dataSource || 'sensortower';
  const dateTye = params?.filter?.granularity || 'monthly';
  let configList: any = [];
  configList = sheetNameList?.filter((item: any) => downloadMetrics?.includes(item.typeValue));
  configList = configList?.map((item: any) => {
    let filterSource = item?.pipeMetricList?.filter(
      (metricItem: any) => metricItem?.source === dataSource,
    );

    filterSource = filterSource?.filter((subItem: any) => {
      if (subItem?.hasOwnProperty('dateType')) {
        return toDateTypeNor[dateTye] === subItem.dateType;
      }
      return true;
    });

    return {
      ...item,
      pipeMetricList: filterSource,
    };
  });
  return configList;
};

// 根据用户勾选下载页签，获取对应页签配置
const getDataKey = (params: any) => {
  const configListTemp = getPageConfig(params);
  return configListTemp?.map((item: any) => item.typeName);
};

// 根据用户勾选下载页签，获取需要调用的接口
const getDownloadApiListObjByType = (params: any) => {
  const {
    iegg_genre_req = [],
    start_date = '',
    end_date = '',
    granularity = '',
    market = '',
    entityType = '',
    filter = {},
  } = params;

  const dataSource = filter?.dataSource || 'sensortower';
  const genreValus = params?.filter?.genres;

  let sourceMetricsTemp = {
    sensortower: ['revenue', 'download'],
  } as any;
  if (dataSource === 'appannie') {
    sourceMetricsTemp = {
      appannie: ['revenue', 'download'],
    };
  }

  const mainGenreValus =
    Array.isArray(genreValus) && genreValus?.length > 0 && genreValus[0] === 'All'
      ? []
      : genreValus;

  const downloadApiListObj = {
    ...downloadApiListConst,
    operationData: {
      ...downloadApiListConst.operationData,
      apiParams: {
        source_metrics: {
          ...sourceMetricsTemp,
        },
        regions: [market],
        genres: genreValus,
        b_growth_ratio: params.ratio_show === 1 || params.ratio_show === '1',
        b_group_by_date: params.downlaod_date_method !== 'aggregated',
        b_group_by_market: true,
        start_date,
        end_date,
        platforms: ['All'],
        granularity,
      },
    },
    byGames: {
      ...downloadApiListConst.byGames,
      apiParams: {
        ...downloadApiListConst.byGames.apiParams,
        market,
        start_date,
        end_date,
        granularity,
        sources: [dataSource],
        entity_type: entityType,
        b_ratio: false,
        order_source: dataSource,
        order_metric: 'revenue',
        select_code: [],
        iegg_genre_req,
        // page_size: 1000,
      },
    },
    byMainGenre: {
      ...downloadApiListConst.byMainGenre,
      apiParams: {
        source_metrics: {
          ...sourceMetricsTemp,
        },
        regions: [market],
        order: 'desc',
        region_type: 'market',
        order_metric: 'revenue',
        metrics: ['revenue', 'download'],
        platforms: ['All'],
        genres: mainGenreValus,
        b_growth_ratio: params.ratio_show === 1 || params.ratio_show === '1',
        b_group_by_date: params.downlaod_date_method !== 'aggregated',
        b_group_by_genre: true,
        start_date,
        end_date,
        granularity,
      },
    },
    byCompanies: {
      ...downloadApiListConst.byCompanies,
      apiParams: {
        ...downloadApiListConst.byCompanies.apiParams,
        market,
        order_source: dataSource,
        sources: [dataSource],
        genres: genreValus,
        start_date,
        end_date,
        granularity,
      },
    },
  };
  return downloadApiListObj;
};

// 设置下载数据指标表头与对应数据配置
const mergeDataCommon = (
  paramsValue: Record<string, any> = {},
  sheetObj: any = {},
  sourceDownloadSegment = {},
) => {
  let result: any[] = [];
  const segments: any = sourceDownloadSegment || {};

  // eslint-disable-next-line no-prototype-builtins
  if (sheetObj?.hasOwnProperty('metricKey')) {
    if (sheetObj?.metricKey === '') {
      // 如果sheetObj?.metricKey 为空，即全部渲染
      result = sheetObj?.pipeMetricList?.map((metricObj: any) => {
        return { Metric: metricObj.title, Source: '' };
      });
    } else if (sheetObj?.metricKey !== '' && Array.isArray(paramsValue[sheetObj?.metricKey])) {
      // 如果指标直接为下载弹窗勾选的，指标字符串数组，且给了指标字段key
      const metricList = paramsValue[sheetObj?.metricKey] || [];
      result = metricList?.map((metric: any) => {
        return { Metric: metric, Source: '' };
      });
    }
  }

  // 旧有逻辑
  const metrics = paramsValue.source_metrics || {};
  // 遍历 source_metric 中的每个键
  Object.keys(metrics)?.forEach((key) => {
    // 获取当前键对应的 metrics 数组
    const currentMetrics = metrics[key] || [];
    // 获取当前键对应的 segments 数组
    const currentSegments = segments[key] || [];

    // 遍历 metrics 数组
    currentMetrics?.forEach((metric: any) => {
      // 遍历 segments 数组
      if (paramsValue.segment_method === 'aggregated' || !paramsValue.segment_method) {
        result.push({ Metric: metric, Source: '' });
      } else {
        if (currentSegments?.length) {
          currentSegments?.forEach((segment: any) => {
            // 将结果添加到结果数组中
            result.push({ Metric: metric, Segment: segment, Source: '' });
          });
        } else {
          result.push({ Metric: metric, Segment: '', Source: '' });
        }
      }
    });
  });

  return result;
};

// 根据条件动态生成处理链
const createProcessor = (paramsValue: any, pipeFrontList: any[]) => {
  const funcsList: any[] = [];
  pipeFrontList?.forEach((item: any) => {
    // 如果是固定字段
    if (item.isFixed && item.isFixed === true) {
      funcsList.push(setTitleByFixed(item));
    } else {
      switch (item.title) {
        case 'Date':
          funcsList.push(setTitleByDateMethod(paramsValue.downlaod_date_method));
          break;
        case 'Market':
          funcsList.push(setTitleByRegionMethod(paramsValue.region_method, true));
          break;
        case 'Genre':
          funcsList.push(setTitleByMainGenreShow(paramsValue.genre_method));
          break;
      }
    }
  });
  return pipe(...funcsList);
};

// 获取下载表头
const getSheetNamesList = (params: Record<string, any> = {}, sheetObj: any = {}) => {
  // 获取下载表格，Basic Info 表头配置
  const pipeFront = createProcessor(params, sheetObj?.pipeFrontList);

  // 获取下载表格，指标表头配置
  const metricList = mergeDataCommon(params, sheetObj);

  const pipeInLoop = pipe(
    setItem,
    setMetricTitle(newMetricMap, params.date_type, 'isObject'),
    setPercentForPCConsole(params.ratio_show),
  );

  // 下载表格表头标题排序
  const excelTitleList = getMobileDetailDownloadTitle(pipeFront, metricList, pipeInLoop);
  return {
    [sheetObj.typeName]: excelTitleList,
  };
};

// 获取下载表头
const getSheetNames = (params: Record<string, any> = {}) => {
  const configList = getPageConfig(params);

  let sheetNameValueList: any = [];
  let sheetNamesValueTemp: any = {};
  sheetNameValueList = configList?.map((item: any) => item.typeName);

  configList?.forEach((item: any) => {
    sheetNamesValueTemp = {
      ...sheetNamesValueTemp,
      ...getSheetNamesList(params, item),
    };
  });

  return {
    sheetName: sheetNameValueList,
    ...sheetNamesValueTemp,
  };
};

// 下载个性化接口参数与表格配置
export default (params: Record<string, any>) => ({
  ...commonSetting,
  isUsingNewMethod: false,
  $$fileName: getFileName(params),
  downloadFetchApi: '/api/v1/intelligence_pc/mobileIeggGenreMetrics',
  dataKey: getDataKey(params),
  regionOptions: params?.regionOptions,
  byDate: params?.downlaod_date_method !== 'aggregated',
  granularity: granularityObject[params?.granularity],
  downloadApiParams: {},
  downloadApiListObj: getDownloadApiListObjByType(params),
  fetchOnlyOnce: false,
  ...getSheetNames(params),
});
